export const outsideServiceAreaMessage = `LookAround is currently available in SF at North Beach, Nob Hill,
                      Russian Hill, Chinatown and Telegraph Hill. Thanks for your interest, we look forward to
                      serving your area soon.`;

export const nearServiceAreaMessage = `LookAround is currently available in SF at North Beach, Nob Hill,
                      Russian Hill, Chinatown and Telegraph Hill. We look forward to sharing our immersive experiences
                      with you when you visit these neighborhoods!`;
